module.exports = __webpack_public_path__ + "img/PaymentEN.c9b49a94.png";